import React from 'react';
import Text from '../Text';
const Description = props => /*#__PURE__*/React.createElement(Text, props);
Description.propTypes = {
  ...Text.propTypes
};
Description.defaultProps = {
  fontSize: 1,
  color: 'gray.7'
};
Description.displayName = 'Description';
export default Description;